import {
  workflowPageViewSchema,
  type WorkflowPageView,
} from "../../shared/workflowPageView";
import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";

function ShowWorkflowPageHeader({ result, interrupted }: ToolUseProps) {
  const view = result?.isError
    ? null
    : workflowPageViewSchema.safeParse(result?.output);
  return (
    <ToolStatus
      icon="earth"
      text={
        view?.success
          ? `Opened ${view.data.route}`
          : result?.isError
            ? "Couldn’t open page"
            : "Opening page…"
      }
      pending={!result && !interrupted}
    />
  );
}

export const showWorkflowPage = (
  onShowPage: (view: WorkflowPageView) => void
): ChatTool => ({
  name: "showWorkflowPage",
  Header: ShowWorkflowPageHeader,
  alwaysLoadOutput: true,
  onActivate: ({ result }) => {
    if (result?.isError) return;
    const view = workflowPageViewSchema.safeParse(result?.output);
    if (view.success) onShowPage(view.data);
  },
});
